'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _isString3 = require('lodash/isString');

var _isString4 = _interopRequireDefault(_isString3);

var _isFinite3 = require('lodash/isFinite');

var _isFinite4 = _interopRequireDefault(_isFinite3);

var _isNumber3 = require('lodash/isNumber');

var _isNumber4 = _interopRequireDefault(_isNumber3);

var _isObjectLike3 = require('lodash/isObjectLike');

var _isObjectLike4 = _interopRequireDefault(_isObjectLike3);

var _isPlainObject3 = require('lodash/isPlainObject');

var _isPlainObject4 = _interopRequireDefault(_isPlainObject3);

exports.asArray = asArray;
exports.asNumberArray = asNumberArray;
exports.asObject = asObject;
exports.asNumber = asNumber;
exports.asBoolean = asBoolean;
exports.asString = asString;
exports.asPostArray = asPostArray;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* types cast helper for API responses with invalid types of data */

function asArray(val) {
  var allowNull = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var castAsNumber = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (allowNull && val === null) {
    return null;
  }
  if ((0, _isString4.default)(val)) {
    if (val.startsWith('(') && val.endsWith(')')) {
      var str = val.substr(1, val.length - 2);
      str = str.split(',');
      var res = [];
      str.map(function (sVal) {
        var arrVal = sVal.trim().replace(/^'/gm, '').replace(/'$/gm, '');
        res.push(castAsNumber ? asNumber(arrVal) : arrVal); // eslint-disable-line no-use-before-define
      });
      return res;
    }
  }
  if (!Array.isArray(val)) {
    return [];
  }
  return val;
}

function asNumberArray(val) {
  var allowNull = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  return asArray(val, allowNull, true);
}

function asObject(val) {
  var asPlain = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var allowNull = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (allowNull && val === null) {
    return null;
  }
  if (asPlain && !(0, _isPlainObject4.default)(val) || !asPlain && !(0, _isObjectLike4.default)(val)) {
    return {};
  }
  return val;
}

function asNumber(val) {
  var isFinite = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var allowNull = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (allowNull && val === null) {
    return null;
  }
  var res = Number(val);
  if (isFinite) {
    return (0, _isFinite4.default)(res) ? res : 0;
  }
  return (0, _isNumber4.default)(res) ? res : 0;
}

function asBoolean(val) {
  var allowNull = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (allowNull && val === null) {
    return null;
  }
  var isNumber = (0, _isFinite4.default)(Number(val));
  if (isNumber) {
    return !!Number(val);
  }
  return !!val;
}

function asString(val) {
  var allowNull = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (allowNull && val === null) {
    return null;
  }
  if ((0, _isString4.default)(val)) {
    return val;
  }
  var isNumber = (0, _isFinite4.default)(Number(val));
  if (isNumber) {
    return '' + Number(val);
  }
  return '';
}

function asPostArray(array) {
  var asStringsArray = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var resultArray = [].concat((0, _toConsumableArray3.default)(array));
  if (asStringsArray) {
    resultArray = resultArray.map(function (item) {
      return '"' + item.toString() + '"';
    });
  }
  return '[' + resultArray.toString() + ']';
}


//////////////////
// WEBPACK FOOTER
// ./src/helpers/TypeCast.js
// module id = 260
// module chunks = 1